import { diffDates } from "@fullcalendar/core";
import { deleteConfirmationAlert, commonClockTimepicker, timePickerMask } from "./common";

window.addEventListener('DOMContentLoaded', (event) => {
    var dateRange = window.$('#dateRange').val();
    if (dateRange !== undefined) {
        let date = dateRange.split("-");
        let fromDate = date[0].replaceAll(".", "-");
        fromDate = fromDate.split("-").reverse().join("-");
        fromDate = fromDate.replaceAll(" ", "");
        let toDate = date[1].replaceAll(".", "-");
        toDate = toDate.split("-").reverse().join("-");
        toDate = toDate.replaceAll(" ", "");
        showDays(fromDate, toDate);
    }
});
// date and time picker
window.$("#dateRange").daterangepicker({
    timepicker: true,
    dateLimit: { days: 6 },
    locale: {
        format: DATE_FORMAT_GUEST,
        firstDay: 1
    },
    minDate: new Date(),
    // step: 15,
    dayOfWeekStart: 1,
    // maxDate: '+7D',
    onShow: function (ct) {
        this.setOptions({

        })
    },
    onChangeYear: function (dateText, inst) {
        var date = moment(dateText).format("DD/MM/YYYY");
        window.$(inst).val(date);
    },
    onChangeMonth: function (dateText, inst) {
        var date = moment(dateText).format("DD/MM/YYYY");
        window.$(inst).val(date);
    }
}, function (start, end, label) {
    showDays(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'));
});
var days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

// to show slots based on date selected
function showDays(fromDate, toDate) {
    // console.log(fromDate, toDate)
    var from = new Date(fromDate);
    var to = new Date(toDate);
    // console.log(from)
    var fromName = days[from.getDay()];
    var toName = days[to.getDay()];

    var totalDays = [];
    var flag = false;

    var from = new Date(fromDate);
    var to = new Date(toDate);

    var d = from;
    while (d <= to) {
        totalDays.push(days[d.getDay()]);
        d = new Date(d.getTime() + (24 * 60 * 60 * 1000));
    }

    // for (let index = 0; index <= days.length; index++) {
    //     console.log(days[index],fromName,toName)
    //     if (days[index] == fromName) {
    //         flag = true;
    //         totalDays.push(days[index]);
    //     }
    //     if (days[index] == toName) {
    //         totalDays.push(days[index])
    //         break;
    //     }
    //     if (flag) {
    //         totalDays.push(days[index])
    //     }
    // }
    days.forEach(element => {
        if (totalDays.includes(element)) {
            $('.exceptionOpenTime').find('.' + element).removeClass('d-none');
            $('.exceptionOpenTime').find('.' + element).show();
        } else {
            $('.exceptionOpenTime').find('.' + element).addClass('d-none');
            $('.exceptionOpenTime').find('.' + element).hide();
        }
    });
}
window.$("#end_date").datetimepicker({
    timepicker: true,
    format: DATE_FORMAT,
    step: 15,
    dayOfWeekStart: 1,
    onShow: function (ct) {
        this.setOptions({
        })
    },
    onChangeYear: function (dateText, inst) {
        var date = moment(dateText).format("DD/MM/YYYY HH:mm");
        window.$(inst).val(date);
    },
    onChangeMonth: function (dateText, inst) {
        var date = moment(dateText).format("DD/MM/YYYY HH:mm");
        window.$(inst).val(date);
    }
});

function changeDateFormat(d, incflag = false) {
    var date = new Date(d);
    var month = date.getMonth() + 1;
    if (incflag) {
        date.setDate(date.getDate() + 1);
    }
    var day = date.getDate();
    var year = date.getFullYear();
    return year + "/" + month + "/" + day;
}
// exception close time save button click
window.$("#saveExeceptionOpentime").on('click', function () {
    window.$(".error").html('');
    window.toastr.remove();
    window.$('#saveExeceptionOpentime').attr('disabled', 'disabled');
    window.axios({
        method: "post",
        url: window.$("#openavailability_form").attr('action'),
        data: window.$("#openavailability_form").serialize() + "&type=close",
    }).then(function (response) {
        window.toastr.success(response.data.message, response.statusText);
        var redirectTo = $("#openavailability_form").attr('redirectto');
        setTimeout(function () {
            window.location = redirectTo;
        }, 1000);
    }).catch(function (error) {
        window.$('#saveExeceptionOpentime').removeAttr('disabled');
        if (typeof error.response !== 'undefined') {
            if (error.response.status == 400) {
                window.$.each(error.response.data, function (key, value) {
                    console.log(value[1])
                    $('.block').find('input.' + key).addClass('error');
                    if (value[1] !== undefined) {
                        window.toastr.error(value[1], error.response.data.statusText);

                    }
                });
                return false;
            }
            window.toastr.error(error.response.data.message, error.response.data.statusText);
        }
    });

});

// data table for exception listing
var table = window.$('.exceptionOpeningTable').DataTable({
    "oLanguage": DATATABLE_LANGUAGE_OPTIONS,
    "aLengthMenu": DATATABLE_MENU_LENGTH_OPTIONS,
    "ordering": false,
    "searching": false,
    "info": false,
    processing: true,
    serverSide: true,
    "ajax": {
        "url": window.$(".exceptionOpeningTable").attr('link'),
        "type": "GET"
    },
    columns: [
        { data: 'dateRange', name: 'Date Range' },
        { data: 'reason', name: 'Reason' },
        { data: 'action', name: 'Action', orderable: false, searchable: false }
    ]
});

/**
 * Delete Exception close time
 */
window.$(document).on('click', '.exceptionOpeningTable .deleteException', function (e) {
    var currentObj = window.$(this);
    // Call method for delete confirmation
    var promise = deleteConfirmationAlert();
    promise.then(function (result) {
        // If confirmation true, do action for delete
        var myTable = $(".exceptionOpeningTable").DataTable({
            bRetrieve: true,
            ajax: window.$(".exceptionOpeningTable").attr('link')
        });
        e.preventDefault();
        window.axios({
            method: "DELETE",
            url: currentObj.attr('link')
        })
            .then(function (response) {
                myTable.ajax.reload();
                window.toastr.success(response.data.message, response.statusText);
            })
            .catch(function (error) {
                window.toastr.error(error.response.data.message, error.response.data.statusText);

            });
        return false;

    }).catch(function (err) {
        return false;
    });

});

/*** ALL DAY SCRIPT */
window.addEventListener('DOMContentLoaded', (event) => {
    if ($("#exception_all_day").is(':checked')) {
        $("#exception_all_day").trigger('change');
    } else {
        $("#exception_all_day").trigger('change');
    }
});
// exceptionOpenTime - Add exceptionOpenTime time block
window.$(document).on('click', ".exceptionOpenTime .plus-icon", function (e) {
    e.preventDefault();
    Promise.resolve(1).then(function resolve() {
        timePickerMask();
        commonClockTimepicker();
    });
    var day = window.$(this).parents('td').attr('key');
    window.$('.exceptionOpenTime').find('.block-container').find('#day').val(day);
    var block = window.$('.exceptionOpenTime').find('.block-container').html();
    window.$(this).siblings('.time-container').append(block);
});

// exceptionOpenTime - Remove the time block
window.$(document).on('click', ".exceptionOpenTime .delete-icon ", function (e) {
    var currentObj = window.$(this);

    // If confirmation true, do action for delete
    if (currentObj.closest('.block').find('.id').val() == "") {
        currentObj.closest('.block').remove();
        return false
    }
    // Call method for delete confirmation
    var promise = deleteConfirmationAlert();
    promise.then(function (result) {
        currentObj.closest('.block').remove();

    }).catch(function (err) {
        return false;
    });

});

// exceptionOpenTime - Cancel the new time block
window.$(document).on('click', ".exceptionOpenTime .cancel-icon ", function (e) {
    var currentObj = window.$(this);
    // If confirmation true, do action for delete
    if (currentObj.closest('.block').find('.id').val() == "") {
        currentObj.closest('.block').remove();
        return false
    }
    window.$(this).closest('.block').find(".delete-icon").removeClass('d-none');
    window.$(this).closest('.block').find(".cancel-icon").addClass('d-none');
    window.$(this).closest('.block').find(".fa-check-circle").addClass('d-none');
    window.$(this).closest('.block').find(".fa-pen").removeClass('d-none');
    window.$(this).closest('.block').find('input').removeClass('d-none');
    window.$(this).closest('.block').find('.time span').removeClass('d-none');
    window.$(this).closest('.block').find('.col').addClass('d-none');
    window.$(this).closest('.block').find('input[type="number"]').attr('readonly', true);
    window.$(this).closest('.block').addClass('disabled');

});


// exceptionOpenTime - Edit the time block
window.$(document).on('click', ".exceptionOpenTime .fa-pen ", function (e) {
    window.$(this).closest('.block').find(".delete-icon").addClass('d-none');
    window.$(this).closest('.block').find(".cancel-icon").removeClass('d-none');
    window.$(this).closest('.block').find(".fa-check-circle").removeClass('d-none');
    window.$(this).addClass('d-none');
    window.$(this).closest('.block').find('span').addClass('d-none');
    window.$(this).closest('.block').removeClass('disabled');
    window.$(this).closest('.block').find('input').removeClass('d-none');
    window.$(this).closest('.block').find('.time span').addClass('d-none');
    window.$(this).closest('.block').find('.col').removeClass('d-none');
    window.$(this).closest('.block').find('input[type="number"]').removeAttr('readonly');
    window.$(this).closest('.block').removeClass('disabled');
});
// exceptionOpenTime - Remove the time block
window.$(document).on('click', ".exceptionOpenTime .save-icon ", function (e) {
    var isValid = true;
    window.$(this).closest('.block').find('input.time').each(function () {
        if (!validationDisplayWithoutMessage(window.$(this))) {
            isValid = false;
            return false;
        } else {
            window.$(this).removeClass('error');
        }
    });
    if (isValid == true) {
        var currentObj = window.$(this);
        window.axios({
            method: "post",
            url: window.$(".exceptionOpenTime").attr('action'),
            data: window.$(this).closest('.block').find('input').serialize(),
        }).then(function (response) {
            reloadPage();
            window.toastr.success(response.data.message, response.statusText);
            currentObj.addClass('d-none');
            currentObj.closest('.block').find(".id").val(response.data.data.id);
            currentObj.closest('.block').find(".fa-pen").removeClass('d-none');
            var end_time = currentObj.closest('.block').find('input[name="end_time"]').val();
            var start_time = currentObj.closest('.block').find('input[name="start_time"]').val();
            currentObj.closest('.block').find('.time span').text(start_time + ' - ' + end_time);
            currentObj.closest('.block').find('.col').addClass('d-none');
            currentObj.closest('.block').find('input[type="number"]').attr('readonly', true);
            currentObj.closest('.block').addClass('disabled');
            currentObj.closest('.block').find('input.cover').removeClass('error');
            currentObj.closest('.block').find(".delete-icon").removeClass('d-none');
            currentObj.closest('.block').find(".cancel-icon").addClass('d-none');

        }).catch(function (error) {
            if (typeof error.response !== 'undefined') {
                if (error.response.status == 400) {
                    window.$.each(error.response.data, function (key, value) {
                        currentObj.closest('.block').find('input.' + key).addClass('error');
                        window.toastr.error(value, error.response.data.statusText);
                    });
                    return false;
                }
                window.toastr.error(error.response.data.message, error.response.data.statusText);
            }

        });
    }
});

function reloadPage() {
    window.axios({
        method: "post",
        url: window.$(".exceptionOpenTime").attr('partialView'),
    }).then(function (response) {
        $(".content_wrapper").html('');
        $(".content_wrapper").html(response.data);
    }).catch(function (error) {
    });
}
function validationDisplayWithoutMessage(currentObject) {
    currentObject.removeClass('error');
    if (currentObject.val() == "" || !validateHhMm(currentObject.val())) {
        currentObject.addClass('error');
        window.toastr.error(window.$(".exceptionOpenTime").attr('invalid-msg'));
        return false;
    }
    return true;
}


// Validate hours and minute format
function validateHhMm(time) {
    return /^([0-1]?[0-9]|2[0-3]):([0-5][0-9])(:[0-5][0-9])?$/.test(time);
}









//axios.post('/abc', {'data':'1'});
//axios.post('/abc', {'data':'1'});
